import React, { createContext, ReactNode, useContext, useMemo } from 'react'
import { SkrottlappParsed } from '../types/types'

interface SkrottlappScanContextProps {
  hasScanned: boolean
  index: number
}

const SkrottlappScanContext = createContext<
  SkrottlappScanContextProps | undefined
>(undefined)

interface SkrottlappScanProviderProps {
  children: ReactNode
  skrottlappScan: SkrottlappParsed | undefined
  index: number
}

export const SkrottlappScanProvider: React.FC<SkrottlappScanProviderProps> = ({
  children,
  skrottlappScan,
  index
}) => {
  const hasScanned = skrottlappScan != null
  const value = useMemo(
    () => ({
      hasScanned,
      index
    }),
    [hasScanned, index]
  )

  return (
    <SkrottlappScanContext.Provider value={value}>
      {children}
    </SkrottlappScanContext.Provider>
  )
}

export const useSkrottlappScan = (): SkrottlappScanContextProps | undefined => {
  const context = useContext(SkrottlappScanContext)
  if (!context) {
    return undefined
  }
  return context
}
